import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";
import {Observer} from "rxjs/Observer";
import {ConfigurationThing} from "../models/configurationThing";
import {ProductStatus} from "../models/change-status/productStatus";
import {FieldResponse} from "../models/FieldResponse";
import {DepartmentsZones, VizixZone, ZoneType} from "../models/zoneDeptRelation";
import {ReportDefinitionResponse, UserResponse, VizixClientService} from "vizixc/dist";
import {ReportExecutionResponse} from "vizixc/dist/interfaces/reportExecution.interface";
import {TableScriptReportResponse} from "../models/TableScriptReportResponse";

import {deserialize} from "serializer.ts/Serializer";
import {
  CONFIGURATION_ERROR,
  DEFAULT_ZONE, FIELD_TYPE_ATTACHMENT, FIELD_TYPE_BOOLEAN, FIELD_TYPE_COORDINATE, FIELD_TYPE_DATE, FIELD_TYPE_IMAGE,
  FIELD_TYPE_NAME,
  FIELD_TYPE_NUMBER,
  FIELD_TYPE_STRING, FIELD_TYPE_TIMESTAMP, FIELD_TYPE_UDF, FIELD_TYPE_ZONE,
  INVALID_FORMAT,
  KEYS_SERIAL,
  NOT_FOUND, SERVER_ERROR,
  STORAGE_TIME_OFFSET,
  TagType,
  THING_BRIDGE_SOURCE_EVENT,
  THING_TYPE_VIZIX_EVENT,
  UNKNOWN_ERROR,
  VALUE_EMPTY,
  VIZIX_EVENT_ACTION_CONNECT,
  VIZIX_EVENT_ACTION_END,
  VIZIX_EVENT_ACTION_PROCESSED,
  VIZIX_EVENT_ACTION_RETRIEVE,
  VIZIX_EVENT_ACTION_START, VIZIX_EVENT_ACTION_WRITE_CREATE_ENCODE_TAG, VIZIX_EVENT_ACTION_WRITE_GET_SERIAL_FROM_THING,
  VIZIX_EVENT_ACTION_WRITE_TAG,
  VIZIX_EVENT_ACTIVITY_ASSOCIATION_CREATE,
  VIZIX_EVENT_ACTIVITY_ASSOCIATION_UPDATE,
  VIZIX_EVENT_ACTIVITY_CHANGE_STATUS,
  VIZIX_EVENT_ACTIVITY_CREATE_DEFAULT_PRODUCT,
  VIZIX_EVENT_ACTIVITY_ENCODE_TAG,
  VIZIX_EVENT_ACTIVITY_LOGIN,
  VIZIX_EVENT_ACTIVITY_LOGOUT,
  VIZIX_EVENT_ACTIVITY_READER_CONNECT,
  VIZIX_EVENT_ACTIVITY_SYNC,
  VIZIX_EVENT_CATEGORY_SECURITY,
  VIZIX_EVENT_CATEGORY_WORKFLOW,
  VIZIX_EVENT_EVENT_TYPE_ERROR,
  VIZIX_EVENT_EVENT_TYPE_INFO,
  VIZIX_EVENT_EVENT_TYPE_WARN,
  VIZIX_EVENT_SOURCE_MOBILE,
  VIZIX_EVENT_STATUS_FAILURE,
  VIZIX_EVENT_STATUS_SUCCESS,
  VIZIX_EVENT_SUB_CATEGORY_AUTHENTICATION,
  VIZIX_EVENT_SUB_CATEGORY_CHANGE_STATUS,
  VIZIX_EVENT_SUB_CATEGORY_CYCLE_COUNT,
  VIZIX_EVENT_SUB_CATEGORY_ENCODE_TAGS,
  VIZIX_EVENT_SUB_CATEGORY_FIND_ITEMS,
  VIZIX_EVENT_SUB_CATEGORY_IDENTIFY_TAG,
  VIZIX_EVENT_SUB_CATEGORY_MANAGE_TAGS,
  VIZIX_EVENT_SUB_CATEGORY_READER,
  VIZIX_EVENT_SUB_CATEGORY_UNASSOCIATED_TAGS,
  VIZIX_EVENT_UDF_ACTION,
  VIZIX_EVENT_UDF_ACTIVITY,
  VIZIX_EVENT_UDF_CATEGORY,
  VIZIX_EVENT_UDF_COUNT,
  VIZIX_EVENT_UDF_DESCRIPTION,
  VIZIX_EVENT_UDF_DETAIL,
  VIZIX_EVENT_UDF_EVENT_DATE,
  VIZIX_EVENT_UDF_EVENT_ID,
  VIZIX_EVENT_UDF_EVENT_TYPE,
  VIZIX_EVENT_UDF_REMOTE_SOURCE,
  VIZIX_EVENT_UDF_SOURCE,
  VIZIX_EVENT_UDF_STATUS,
  VIZIX_EVENT_UDF_SUB_CATEGORY,
  VIZIX_EVENT_UDF_USER,
  VIZIX_EVENT_UDF_USER_GROUP,
  VIZIX_EVENT_UDF_USER_TENANT,
  VizixEventAction,
  VizixEventActivity,
  VizixEventCategory,
  VizixEventEventType,
  VizixEventSource,
  VizixEventStatus,
  VizixEventSubCategory
} from "../app/app.constants";
import {VizixEventItem} from "../models/VizixEventItem";
import {PatchThingRequestItem} from "../models/PatchThingRequestItem";
import {Constants} from "vizixc/dist/utils/vizixconstants";
import {ErrorResponse} from "../models/ErrorResponse";
import {StringUDF} from "../models/UDFs/StringUDF";
import {NumberUDF} from "../models/UDFs/NumberUDF";
import {FilterItem} from "../models/FilterItem";
import {FilterItemValue} from "../models/FilterItemValue";
import {ReportFilter} from 'vizixc/dist/interfaces/report.filter.interface';

@Injectable()
export class VizixService {

  private tag = '[VIZIX_SERVICE]';

  public configurationApp: ConfigurationThing;
  public baseURLConnected: string;
  public baseURLToShow: string;
  public baseHost: string;
  private storeID;
  public zoneDeptList: DepartmentsZones[];
  private userResponse: UserResponse;
  public configurationList: ConfigurationThing[];
  private _thingTypeCode = 'thingTypeCode';

  public identifyTagReportDefinition: ReportDefinitionResponse;
  public identifyProductReportDefinition: ReportDefinitionResponse;
  public itemDataTypes = [];
  public productsDataTypes = [];

  private vizixEventGroup: string;

  constructor(private _vizixClient: VizixClientService) {
    this.configurationList = [];
  }

  clearVizixService() {
    this.configurationApp = null;
    this.zoneDeptList = [];
    this.vizixEventGroup = null;
  }

  VizixInit(baseURL: string, port: string, protocol: string, clientId: string) {
    // this._vizixClient.create(protocol + baseURL);
    this.baseHost = baseURL;
    this.baseURLConnected = protocol + baseURL;
    this.baseURLToShow = protocol + baseURL.split(":")[0];
    this._vizixClient.create(this.baseURLConnected, clientId);
    this._vizixClient.setRequestTimeout(Constants._defaultTimeout);

    // this._vizixClient.$config.port = port;
  }

  VizixEnableGzipCompression(isEnabled: boolean) {
    this._vizixClient.enableGzipCompression(isEnabled);
  }


  VizixLogin(user: string, pwd: string): Observable<boolean> {
    return Observable.create((observer: Observer<boolean>) => {
      this._vizixClient.login(user, pwd)
        .subscribe((data: UserResponse) => {
            this.userResponse = data;

            observer.next(true);
            observer.complete();
          },
          (err) => {
            observer.error(err);
            observer.complete();
          });
    });
  }


  VizixGetConfigList(): Observable<ConfigurationThing[]> {
    return Observable.create((observer: Observer<ConfigurationThing[]>) => {
      this.configurationList = [];
      console.log(this.tag, "store ID" + this.storeID);
      this._vizixClient.getThingsByThingType("ConfigurationThing").subscribe((data: any) => {
          console.log(this.tag, 'getConfigListResponse');
          console.log(this.tag, data);
          for (let config of data) {
            console.log(this.tag, 'config from response');
            console.log(this.tag, config);
            let configuration = deserialize<ConfigurationThing>(ConfigurationThing, config);
            console.log(this.tag, 'deserialized config');
            console.log(this.tag, configuration);

            if (configuration.StoreID == this.storeID) {
              this.configurationList.push(configuration);
            }
          }
        },
        (err) => {
          console.log(this.tag, 'error - ' + err);
          observer.error(err);
          observer.complete();
        },
        () => {
          console.log(this.tag, 'configuration list result');
          console.log(this.tag, this.configurationList);
          observer.next(this.configurationList);
          observer.complete();
        });
    });
  }

  VizixUpdateConfig(id: number): Observable<any> {
    return Observable.create((observer: Observer<any>) => { // TODO: Add to Vizix SDK FieldsResponse
      this._vizixClient.getThingById(id).subscribe((data: any) => {
          console.log(this.tag, 'response');
          console.log(this.tag, data);

          // Here we parse the response to a configuration thing object
          let configurationThing = deserialize<ConfigurationThing>(ConfigurationThing, data[0]);
          this.configurationApp = configurationThing;


          this._vizixClient.enableGzipCompression(this.configurationApp.AppParametersConfiguration.EnableGzipCompression.value);

          this._vizixClient.setRequestTimeout(this.configurationApp.AppParametersConfiguration.RequestTimeout.value);
          if (this.configurationApp.AppParametersConfiguration.RenewTokenAttempts) {
            this._vizixClient.setRenewTokenAttempts(this.configurationApp.AppParametersConfiguration.RenewTokenAttempts.value);
          }

          observer.next(configurationThing);
        },
        (err) => {
          console.log(this.tag, 'error - ' + err);
          observer.error(err);
          observer.complete();
        },
        () => {
          observer.complete();
        });
    });
  }

  /**
   * Gets the next filters based on an input array of filters
   * @param {Array<FilterItemValue>} selectedFilterValues
   * @returns {Observer<FilterItem>} a FilterItem with the corresponding filter label and values
   * @constructor
   */
  VizixGetCycleCountFilters(selectedFilterValues: Array<FilterItemValue>): Observable<FilterItem> {
    return Observable.create((observer: Observer<FilterItem>) => {
      let requestBody = {};
      for (let filterItemValue of selectedFilterValues) {
        requestBody[filterItemValue.parentLabel] = filterItemValue.value;
      }

      // TODO: CHANGE REPORT EXECUTION TABLE SCRIPT TYPE TO TABLESCRIPTREPORTRESPONSE
      this._vizixClient.reportExecutionTableScript(215,
        requestBody, {'pageNumber': '1', 'pageSize': '100000'}).subscribe((response: ReportExecutionResponse) => {

        let cycleCountFiltersResponse = deserialize<TableScriptReportResponse>(TableScriptReportResponse, response);
        console.log('Deserialized Response: ', cycleCountFiltersResponse);

        let valuesArray: FilterItemValue[] = [];
        let filterLabel: string = cycleCountFiltersResponse.columnNames[0];

        for (let responseRow of cycleCountFiltersResponse.data) {
          valuesArray.push(new FilterItemValue(filterLabel, responseRow[0], false));
        }

        observer.next(new FilterItem(filterLabel.split('|')[2], filterLabel, valuesArray));
      })
    });
  }

  // It returns a map [{name: UDF, dataTypeId: 13}]
  VizixGetDataType(thingTypeCode: string): Observable<any> {
    return Observable.create((observer: Observer<any>) => { // TODO: Add to Vizix SDK FieldsResponse
      this._vizixClient.getFieldByThingType(thingTypeCode).subscribe((data: any) => {
          console.log(this.tag, 'getDataTypeResponse');
          console.log(this.tag, data);

          let dataTypes: any[] = [];
          let fieldResponse = deserialize<FieldResponse>(FieldResponse, data);

          for (let field of fieldResponse.results[0].fields) {
            let dataType = field.dataType;
            dataTypes.push({'name': field.name, 'dataTypeId': dataType.id});
          }

          if (thingTypeCode == this.configurationApp.AppParametersConfiguration.ThingTypeCodeItem.value) {
            this.itemDataTypes = dataTypes;
          } else if (thingTypeCode == this.configurationApp.AppParametersConfiguration.ThingTypeCodeProduct.value) {
            this.productsDataTypes = dataTypes;
          }

          observer.next(dataTypes);
        },
        (err) => {
          console.log(this.tag, 'error - ' + err);
          observer.error(err);
          observer.complete();
        },
        () => {
          observer.complete();
        });
    });
  }

  VizixGetReportDefinitionChangeStatus(): Observable<ReportDefinitionResponse> {
    return Observable.create((observer: Observer<ReportDefinitionResponse>) => {
      this._vizixClient.GetReportDefinition(this.configurationApp.ChangeStatusConfiguration.ChangeStatusReportId.value,
        {'only': 'id,name,reportFilter,reportProperty,reportEntryOption'}).subscribe((data: ReportDefinitionResponse) => {
          console.log(this.tag, 'Report Definition Response');
          console.log(this.tag, data);
          observer.next(data);
        },
        (err) => {
          console.log(this.tag, 'errorGetConfig', err);
          observer.error(err);
          observer.complete();
        },
        () => {
          observer.complete();
        });
    });
  }

  VizixGetReportDefinitionLookup(): Observable<ReportDefinitionResponse> {
    let params = {'only': 'id,name,reportFilter,reportProperty,reportEntryOption'}
    return Observable.create((observer: Observer<ReportDefinitionResponse>) => {
      this._vizixClient.GetReportDefinition(this.configurationApp.LookupConfiguration.LookupReportId.value,
        params).subscribe((data: ReportDefinitionResponse) => {
          console.log(this.tag, 'Report Definition Response');
          console.log(this.tag, data);
          observer.next(data);
        },
        (err) => {
          console.log(this.tag, 'errorGetConfig', err);
          observer.error(err);
          observer.complete();
        },
        () => {
          observer.complete();
        });
    });
  }

  VizixGetReportDefinitionIdentifyTag(): Observable<ReportDefinitionResponse> {
    return Observable.create((observer: Observer<ReportDefinitionResponse>) => {
      this._vizixClient.GetReportDefinition(this.configurationApp.IdentifyItemConfiguration.IdentifyItemReportId.value,
        {'only': 'id,name,reportFilter,reportProperty,reportEntryOption'}).subscribe((data: ReportDefinitionResponse) => {
          console.log(this.tag, 'Report Definition Response');
          console.log(this.tag, data);

          // Save for report execution usage
          this.identifyTagReportDefinition = data;
          observer.next(data);
        },
        (err) => {
          console.log(this.tag, 'errorGetConfig', err);
          observer.error(err);
          observer.complete();
        },
        () => {
          observer.complete();
        });
    });
  }

  VizixGetReportDefinitionCycleCountFiltered(): Observable<ReportDefinitionResponse> {
    return Observable.create((observer: Observer<ReportDefinitionResponse>) => {
      this._vizixClient.GetReportDefinition(215,
        {'only': 'id,name,reportFilter,reportProperty,reportEntryOption'}).subscribe((data: ReportDefinitionResponse) => {
          console.log('Report Definition Response');
          console.log(data);

          // Save for report execution usage
          this.identifyTagReportDefinition = data;
          observer.next(data);
        },
        (err) => {
          console.log('errorGetConfig', err);
          observer.error(err);
          observer.complete();
        },
        () => {
          observer.complete();
        });
    });
  }

  VizixGetReportDefinitionIdentifyProduct(): Observable<ReportDefinitionResponse> {
    return Observable.create((observer: Observer<ReportDefinitionResponse>) => {
      this._vizixClient.GetReportDefinition(this.configurationApp.IdentifyItemConfiguration.IdentifyProductReportId.value,
        {'only': 'id,name,reportFilter,reportProperty,reportEntryOption'}).subscribe((data: ReportDefinitionResponse) => {
          console.log(this.tag, 'Report Definition Response');
          console.log(this.tag, data);

          // Save for report execution usage
          this.identifyProductReportDefinition = data;

          observer.next(data);
        },
        (err) => {
          console.log(this.tag, 'errorGetConfig', err);
          observer.error(err);
          observer.complete();
        },
        () => {
          observer.complete();
        });
    });
  }

  VizixPostReportExecutionChangeStatus(body: any): Observable<ReportExecutionResponse> {
    return Observable.create((observer: Observer<ReportExecutionResponse>) => {
      this._vizixClient.mortalReport({
        id: this.configurationApp.ChangeStatusConfiguration.ChangeStatusReportId.value,
        body: body,
        headers: {'pageNumber': '1', 'pageSize': '2'}
      })
        .subscribe((data: ReportExecutionResponse) => {
            console.log(this.tag, 'Report Execution Response', data);
            observer.next(data);
          },
          (err) => {
            console.log(this.tag, 'errorGetConfig', err);
            observer.error(err);
            observer.complete();
          },
          () => {
            console.log(this.tag, 'complete');
            observer.complete();
          });

    });
  }

  VizixPostReportExecutionCycleCount(body: any): Observable<TableScriptReportResponse> {
    return Observable.create((observer: Observer<TableScriptReportResponse>) => {
      this._vizixClient.mortalReport({
        id: this.configurationApp.CycleCountConfiguration.ExpectedReportId.value,
        body: body,
        headers: {'pageNumber': '1', 'pageSize': '100000'}
      }) // TODO: ANALYZE WHY!?
        .subscribe((data: ReportExecutionResponse) => {
            console.log(this.tag, 'Report Execution Response', data);

            let cycleCountExpectedResponse = deserialize<TableScriptReportResponse>(TableScriptReportResponse, data);
            console.log(this.tag, 'Deserialized Response: ', cycleCountExpectedResponse);

            observer.next(cycleCountExpectedResponse);
          },
          (err) => {
            console.log(this.tag, 'errorGetConfig', err);
            observer.error(err);
            observer.complete();
          },
          () => {
            console.log(this.tag, 'complete');
            observer.complete();
          });

    });
  }


  VizixPostReportExecutionZones(isRetry: boolean = false): Observable<boolean> {
    this.zoneDeptList = [];

    let body = {};
    if (isRetry) {
      body[this.configurationApp.AppParametersConfiguration.FilterLabelStoreId.value] = DEFAULT_ZONE;
    } else {
      body[this.configurationApp.AppParametersConfiguration.FilterLabelStoreId.value] = this.storeID;
    }

    return Observable.create((observer: Observer<boolean>) => {

      this._vizixClient.mortalReport({
        id: this.configurationApp.AppParametersConfiguration.ZoneReportId.value,
        body: body,
        headers: {'pageNumber': '1', 'pageSize': '100000'}
      }) // TODO: ANALYZE WHY!?
        .subscribe((data: ReportExecutionResponse) => {
            console.log(this.tag, 'Report Execution Response', data);

            let zonesTableScriptResponse = deserialize<ReportExecutionResponse>(ReportExecutionResponse, data);
            console.log(this.tag, 'Deserialized Response: ', zonesTableScriptResponse);


            for (let zoneRow of zonesTableScriptResponse.results) {

              let vizixZone = new VizixZone(
                String(zoneRow["serial"]),
                String(zoneRow["StoreID"]),
                String(zoneRow["StoreName"]),
                String(zoneRow["Department"]),
                String(zoneRow["ZonePickList"]),
                String(zoneRow["ZoneTypeCode"]),
                String(zoneRow["ZoneTypeID"]),
                zoneRow["All"] == 'true'
              );

              // the zone(row) may have multiple different zones included.
              // Iterating object 'zone' will have only arrays of size 1
              for (let zone of vizixZone.getIncludedZones()) {

                let zoneType = new ZoneType();

                if (zone.StoreID == this.storeID || zone.StoreID == DEFAULT_ZONE) {
                  // First check if the zoneDept is already on the list
                  let index = this.zoneDeptList.findIndex(x => x.DeptName == zone.Department);
                  if (index > -1) {
                    zoneType.idZone = zone.ZoneTypeID[0];
                    zoneType.zoneTypeCode = zone.ZoneTypeCode[0];
                    zoneType.name = zone.ZonePickList[0];
                    zoneType.id = zone.Department;
                    zoneType.codeZone = zone.Department;
                    zoneType.storeId = zone.StoreID;

                    this.zoneDeptList[index].Zones.push(zoneType);
                  }
                  else {
                    let newDepartment: DepartmentsZones = new DepartmentsZones();
                    // getting the name of the department
                    // let nameDepartment = "";
                    // let splitName = zone.Department.split("_");
                    // for (let i = 1; i < splitName.length; i++) {
                    //   if (splitName[i])
                    //     nameDepartment = nameDepartment + splitName[i];
                    // }
                    // creating the new department
                    newDepartment.DeptName = zone.Department;
                    newDepartment.DeptId = zone.serialNumber;
                    newDepartment.ALL = zone.All;

                    zoneType.idZone = zone.ZoneTypeID[0];
                    zoneType.zoneTypeCode = zone.ZoneTypeCode[0];
                    zoneType.name = zone.ZonePickList[0];
                    zoneType.id = zone.Department;
                    zoneType.codeZone = zone.Department;
                    zoneType.storeId = zone.StoreID;

                    newDepartment.Zones = [];
                    newDepartment.Zones.push(zoneType);
                    this.zoneDeptList.push(newDepartment);
                  }
                }

              }
            }

            // We sort the list to show All departments on top
            this.zoneDeptList.sort((zoneDept1, zoneDept2) => {
              if (zoneDept1.ALL == zoneDept2.ALL) return 0;
              return zoneDept1.ALL && !zoneDept2.ALL ? -1 : 1;
            });

            console.log(this.tag, 'ZoneDeptList', this.zoneDeptList);

            observer.next(this.zoneDeptList.length > 0);

            // if (this.zoneDeptList.length == 0 && !isRetry) {
            //   return Observable.of(true).subscribe();
            // }
            // else {
            //   /*if(retryObserver) {
            //     retryObserver.next(this.zoneDeptList.length > 0);
            //   } else {
            //     observer.next(this.zoneDeptList.length > 0);
            //   }*/
            //
            // }

          },
          (err) => {
            console.log(this.tag, 'errorVizixPostReportExecutionZones', err);
            observer.error(err);
            observer.complete();
          },
          () => {
            console.log(this.tag, 'complete');
            observer.complete();
          });

    });
  }

  VizixPostReportExecutionCycleCountTotalReads(body: any): Observable<ReportExecutionResponse> {
    return Observable.create((observer: Observer<ReportExecutionResponse>) => {
      this._vizixClient.mortalReport({
        id: this.configurationApp.CycleCountConfiguration.LastCycleCountReportId.value, body: body,
        headers: {'pageNumber': '1', 'pageSize': '100000'}
      }) // TODO: ANALYZE WHY!?
        .subscribe((data: ReportExecutionResponse) => {
            console.log(this.tag, 'Report Execution Response');
            console.log(this.tag, data);
            observer.next(data);
          },
          (err) => {
            console.log(this.tag, 'errorGetConfig', err);
            observer.error(err);
            observer.complete();
          },
          () => {
            console.log(this.tag, 'complete');
            observer.complete();
          });

    });
  }

  VizixUpdateReportDefinitionIdentifyTag() {
    // We update the report definition for both reports
    this.VizixGetReportDefinitionIdentifyTag().subscribe(() => {
      this.VizixGetReportDefinitionIdentifyProduct().subscribe(() => {
        this.VizixGetDataType(this.configurationApp.AppParametersConfiguration.ThingTypeCodeItem.value).subscribe(() => {
          this.VizixGetDataType(this.configurationApp.AppParametersConfiguration.ThingTypeCodeProduct.value).subscribe(() => {
            console.log(this.tag, 'Report definition (IdentifyTag) and Data Types updated for thing types Item and Product');
          }, (error) => {
            console.log(this.tag, 'Error getting data types Product', error);
          });
        }, (error) => {
          console.log(this.tag, 'Error getting data types Item', error);
        });
      }, (error) => {
        console.log(this.tag, 'Error getting report definition Identify Product', error);
      });
    }, (error) => {
      console.log(this.tag, 'Error getting report definition Identify Tag', error);
    });
  }

  // original Tag means the tag without padding
  VizixPostReportExecutionFindItemIdentify(tagType: TagType, tag: string): Observable<any> {
    return Observable.create((observer: Observer<any>) => {

      if (!this.identifyTagReportDefinition || !this.identifyProductReportDefinition) {
        observer.error(new ErrorResponse('Report definition not set!', CONFIGURATION_ERROR));
      }

      let body = {};

      // First methods will work immediately if the tagType is known, if the tagType is unknown, we will try doing
      // an autopad to UPC first. If no results on the server, we try autopad to SKU. If no results, we go to observer.error.

      if (tagType == TagType.UPC) { // If it was first recognized as UPC, we dont try to recognize it as SKU. Just send the response.
        console.log(this.tag, 'UPC Tag');
        body[this.configurationApp.IdentifyItemConfiguration.FilterLabelUPC.value] = tag;
        this.lookupProductObservable(body).then(response => {
          observer.next({response: response, tagType: TagType.UPC});
        }, error => {
          observer.error(error);
        }).catch(error => {
          observer.error(new ErrorResponse('Unknown Error', UNKNOWN_ERROR));
        });

      } else if (tagType == TagType.SKU) {
        console.log(this.tag, 'SKU Tag');
        body[this.configurationApp.IdentifyItemConfiguration.FilterLabelSKU.value] = tag;
        this.lookupProductObservable(body).then(response => {
          console.log(this.tag, 'FOUND BY PRODUCT');
          observer.next({response: response, tagType: TagType.SKU});
        }, error => {
          console.log(this.tag, 'NOT FOUND BY PRODUCT');
          observer.error(error);
        }).catch(error => {
          console.log(this.tag, 'ERROR BY PRODUCT');
          observer.error(new ErrorResponse('Unknown Error', UNKNOWN_ERROR));
        });

      } else if (tagType == TagType.EPC) {
        console.log(this.tag, 'EPC Tag');
        body[this.configurationApp.IdentifyItemConfiguration.FilterLabelRFID.value] = tag;
        this.lookupItemObservable(body).then(response => {
          observer.next({response: response, tagType: TagType.EPC});
        }, error => {
          observer.error(error);
        }).catch(error => {
          observer.error(new ErrorResponse('Unknown Error', UNKNOWN_ERROR));
        });

      } else if (tagType == TagType.UNKNOWN) { // It may be UPC or SKU, we analyze if results.length > 0, if not, we try with SKU
        console.log(this.tag, 'Unknown Tag');

        let paddedUPC = this.validateUpc(this.padUpc(tag));

        if (paddedUPC && paddedUPC != '') {
          console.log(this.tag, 'Trying as UPC');

          body[this.configurationApp.IdentifyItemConfiguration.FilterLabelUPC.value] = paddedUPC;
          this.lookupProductObservable(body).then(response => { // The tag was found on UPC
            console.log(this.tag, 'Sending response on observable');
            observer.next({response: response, tagType: TagType.UPC});
          }, error => { // Tag not found, try with SKU
            if (error.errorCode == NOT_FOUND) {
              let paddedSKU = this.validateSku(this.padSku(tag));
              if (paddedSKU && paddedSKU != '') {
                console.log(this.tag, 'Trying as SKU');

                body = {}; // Reset body
                body[this.configurationApp.IdentifyItemConfiguration.FilterLabelSKU.value] = paddedSKU;
                this.lookupProductObservable(body).then(response => { // The tag was found on SKU
                  observer.next({response: response, tagType: TagType.SKU});

                }, error => { // Tag not found
                  observer.error(new ErrorResponse('Tag not found!', NOT_FOUND));
                });
              }
              else {
                console.log(this.tag, 'TOO LONG SKU!');
                observer.error(new ErrorResponse('Padding couldn\'t be made. Tag too long for SKU?', NOT_FOUND));
              }
            } else {
              observer.error(new ErrorResponse('Server Error', SERVER_ERROR));
            }

          }).catch(error => {
            observer.error(new ErrorResponse('Unknown Error', UNKNOWN_ERROR));
          });
        }
        else {
          console.log(this.tag, 'TOO LONG UPC!');
          observer.error(new ErrorResponse('Padding couldn\'t be made. Tag too long for UPC?', INVALID_FORMAT));
        }
      } else {
        console.log(this.tag, 'TagType not recognized');
      }
    });
  }


  VizixPostReportExecutionLookUp(body: any): Observable<any> {
    const config = {
      id: this.configurationApp.LookupConfiguration.LookupReportId.value,
      body,
      headers: {
        pageNumber: '1',
        pageSize: '-1'
      }
    };
    return Observable.create((observer: Observer<TableScriptReportResponse>) => {
      this._vizixClient.mortalReport(config).subscribe((data: ReportExecutionResponse) => {
          console.log(this.tag, 'Report Execution Response', data);

          let lookUpResponse = deserialize<TableScriptReportResponse>(TableScriptReportResponse, data);
          console.log("-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*--*-");
          console.log(this.tag, 'Deserialized Response: ', lookUpResponse);
          console.log("-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*--*-");

          observer.next(lookUpResponse);
        },
        (err) => {
          console.log(this.tag, 'errorGetConfig', err);
          observer.error(err);
          observer.complete();
        },
        () => {
          console.log(this.tag, 'complete');
          observer.complete();
        });

    });
  }

  // This is promise, because we can call it multiple times for UPC or SKU, the returned Observable is global (private)
  private lookupProductObservable(body: {}): Promise<ReportExecutionResponse> {
    return new Promise<ReportExecutionResponse>((resolve, reject) => {
      this._vizixClient.reportExecution(this.configurationApp.IdentifyItemConfiguration.IdentifyProductReportId.value, body,
        {'pageNumber': '1', 'pageSize': '100000'})
        .subscribe((data: ReportExecutionResponse) => {
            console.log(this.tag, 'Report Execution Response', data);

            let findItemIdentifyResponse = deserialize<ReportExecutionResponse>(ReportExecutionResponse, data);
            console.log(this.tag, 'Deserialized Response: ', findItemIdentifyResponse);

            if (findItemIdentifyResponse.results.length > 0) {
              resolve(findItemIdentifyResponse); // Result found!
            } else {
              reject({message: 'Tag not found!', errorCode: NOT_FOUND}); // No Tag found!
            }
          },
          (err) => {
            console.log(this.tag, 'Error Report Execution', err);
            reject(err);
          },
          () => {
            console.log(this.tag, 'Report Execution Complete');
          });

    });
  }

  // This is observable because its response, for RFID tag must be tha same
  private lookupItemObservable(body: {}): Promise<ReportExecutionResponse> {
    return new Promise<ReportExecutionResponse>((resolve, reject) => {
      this._vizixClient.reportExecution(this.configurationApp.IdentifyItemConfiguration.IdentifyItemReportId.value, body,
        {'pageNumber': '1', 'pageSize': '100000'})
        .subscribe((data: ReportExecutionResponse) => {
            console.log(this.tag, 'Report Execution Response', data);

            let findItemIdentifyResponse = deserialize<ReportExecutionResponse>(ReportExecutionResponse, data);
            console.log(this.tag, 'Deserialized Response: ', findItemIdentifyResponse);

            if (findItemIdentifyResponse.results.length > 0) {
              resolve(findItemIdentifyResponse);
            } else {
              reject({message: 'Tag not found!', errorCode: NOT_FOUND});
            }
          },
          (err) => {
            console.log(this.tag, 'Error Report Execution', err);
            reject(err);
          },
          () => {
            console.log(this.tag, 'complete');
          });

    });
  }

  observableError(message: string) {
    return Observable.create((observer: Observer<any>) => {
      observer.error(message);
      observer.complete();
    });
  }

  VizixPostReportExecutionFindItemExpected(body: any): Observable<TableScriptReportResponse> {
    return Observable.create((observer: Observer<TableScriptReportResponse>) => {
      this._vizixClient.mortalReport({
        id: this.configurationApp.FindItemConfiguration.FindItemExpectedReportId.value,
        body: body,
        headers: {'pageNumber': '1', 'pageSize': '100000'}
      }) // TODO: ANALYZE WHY!?
        .subscribe((data: ReportExecutionResponse) => {
            console.log(this.tag, 'Report Execution Response', data);

            let findItemExpectedResponse = deserialize<TableScriptReportResponse>(TableScriptReportResponse, data);
            console.log(this.tag, 'Deserialized Response: ', findItemExpectedResponse);

            observer.next(findItemExpectedResponse);
          },
          (err) => {
            console.log(this.tag, 'Error Expected Report Execution ' + err);
            observer.error(err);
            observer.complete();
          },
          () => {
            console.log(this.tag, 'complete');
            observer.complete();
          });

    });
  }

  VizixPostReportExecutionSOH(body: any): Observable<{ label: string, qty: number }> {
    return Observable.create((observer: Observer<{ label: string, qty: number }>) => {
      this._vizixClient.mortalReport({
        id: this.configurationApp.IdentifyItemConfiguration.SOHReportId.value,
        body: body,
        headers: {'pageNumber': '1', 'pageSize': '2'}
      })
        .subscribe((data: ReportExecutionResponse) => {
            let sohResponse = deserialize<TableScriptReportResponse>(TableScriptReportResponse, data);
            console.log(this.tag, 'Report Execution Response: ', sohResponse);
            observer.next({
              label: sohResponse.columnNames[0],
              qty: Number((sohResponse.data[0] ? (sohResponse.data[0][0] || 0) : 0) || 0)
            });
          },
          (err) => {
            console.log(this.tag, 'errorGetConfig - ', err);
            observer.error(err);
            observer.complete();
          },
          () => {
            console.log(this.tag, 'complete');
            observer.complete();
          });

    });
  }

  VizixPostReportExecutionUnassociatedTags(body, pageNumber, pageSize, observable?: Observable<ReportExecutionResponse | ReportDefinitionResponse>): Observable<ReportExecutionResponse> {
    return Observable.create((observer: Observer<ReportExecutionResponse>) => {
      this._vizixClient.mortalReport({
        id: this.configurationApp.UnassociatedConfiguration.ReportUnassociatedId.value,
        body: body,
        headers: {
          pageNumber,
          pageSize
        }
      })
        .subscribe((data: ReportExecutionResponse) => {
            console.log(this.tag, 'Unassociated Tags ReportExecution Response', data);
            observer.next(data);
          },
          (err) => {
            console.log(this.tag, 'Unassociated Tags ReportExecution ERROR ', err);
            observer.error(err);
          },
          () => {
            observer.complete();
          });
    });
  }

  saveToEvent(vizixEvent: VizixEventItem, bridgeCode?: string, thingTypeCode?: string): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {

      console.log(this.tag, 'Event to save', vizixEvent);

      if (!this.vizixEventGroup) {
        this.VizixGetVizixEventsGroup(this.configurationApp.AppParametersConfiguration.ViZIxEventSerial.value).subscribe((group) => {
          console.log(this.tag, 'Group to use in vizixEvent', group);
          this.vizixEventGroup = group;
          if (this.vizixEventGroup) {
            this.uploadEvent(vizixEvent, resolve, reject, bridgeCode, thingTypeCode);
          } else {
            console.log(this.tag, 'Could not get the vizixEvent group');
          }
        }, (error) => {
          console.log(this.tag, 'An error occurred getting ViZix Event group', error);
          if (this.vizixEventGroup) {
            this.uploadEvent(vizixEvent, resolve, reject, bridgeCode, thingTypeCode);
          } else {
            console.log(this.tag, 'Could not get the vizixEvent group');
          }
        });
      } else {
        console.log(this.tag, 'Group to use in vizixEvent', this.vizixEventGroup);
        this.uploadEvent(vizixEvent, resolve, reject, bridgeCode, thingTypeCode);
      }
    });
  }

  VizixGetProductStatusColor(vizixProductStatusList: string[]): Observable<ProductStatus[]> {
    // The list to return after request
    let productStatusListReturn: ProductStatus[] = [];
    return Observable.create((observer: Observer<ProductStatus[]>) => {
      this._vizixClient.getThingsByThingType(this.configurationApp.ChangeStatusConfiguration.ProductStatusThingTypeCode.value)
        .subscribe((data: any) => {
            console.log(this.tag, 'ProductStatusThingsResponse', data);
            for (let vizixProductStatus of data) {
              console.log(this.tag, 'ProductStatus thing from vizix', vizixProductStatus);

              let productStatus = deserialize<ProductStatus>(ProductStatus, vizixProductStatus);
              console.log(this.tag, 'deserialized Product Status', productStatus);
              if (vizixProductStatusList.indexOf(productStatus.serialNumber) > -1) {
                productStatusListReturn.push(productStatus);
              }
            }
            // Now sort with positions
            var sortedProductStatusListReturn: ProductStatus[] = productStatusListReturn.sort((obj1, obj2) => {
              if (obj1.position > obj2.position) {
                return 1;
              }
              if (obj1.position < obj2.position) {
                return -1;
              }
              return 0;
            });
            observer.next(sortedProductStatusListReturn);
          },
          (err) => {
            console.log(this.tag, 'errorGetConfig', err);
            observer.error(err);
          },
          () => {
            observer.complete();
          });
    });
  }

  VizixPatchItem(body: any, params?: any, bridgeCode?: string, thingTypeCode?: string, source?: string): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this._vizixClient.patchThing(body,
        params,
        bridgeCode,
        thingTypeCode,
        source,
        this.configurationApp.AppParametersConfiguration.EnableTimestamp.value)
        .subscribe((data: ReportExecutionResponse) => {
            console.log(this.tag, 'PatchItem Response', data);
            observer.next(data);
            observer.complete();
          },
          (err) => {
            console.log(this.tag, 'Error', err);
            observer.error(err);
            observer.complete();
          },
          () => {
            console.log(this.tag, 'PatchItem complete');
            observer.complete();
          });
    });
  }

  VizixGetThingMongo(thingTypeCode: string, UDFfieldValue: string, fieldValue: string): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      let whereThing = this._thingTypeCode + '=' + "'" + thingTypeCode + "'";
      let whereFieldValue = UDFfieldValue + '=' + "'" + fieldValue + "'";
      this._vizixClient.getThingMongo(whereThing, whereFieldValue)
        .subscribe((data: any) => {
            console.log(this.tag, data);
            observer.next(data);
          },
          (err) => {
            console.log(this.tag, 'VizixGetThingMongo - ' + err);
            observer.error(err);
          },
          () => {
            observer.complete();
          });
    });
  }

  VizixGetThingAssociation(thingTypeCode: string, UDFfield: string, UDFfieldValue: string, isItem?: boolean): Observable<any> {
    UDFfield = this.putUDFValueProperty(UDFfield);
    return Observable.create((observer: Observer<any>) => {
      let whereValue = UDFfield + '=' + "'" + UDFfieldValue + "'" + "&" + this._thingTypeCode + '=' + "'" + thingTypeCode + "'";
      let headerParams;
      if (isItem) {
        let itemOnlyFields = 'serialNumber,' + this.configurationApp.AssociationConfiguration.ItemUPCUDF.value;
        headerParams = {
          'only': itemOnlyFields,
          'treeView': 'false',
          'returnFavorite': 'false',
          'reportApi': 'false',
          'includeResults': 'true',
          'includeTotal': 'true'
        };
      } else {
        headerParams = {
          'only': this.configurationApp.AssociationConfiguration.DefaultProductUPCUDF.value,
          'treeView': 'false',
          'returnFavorite': 'false',
          'reportApi': 'false',
          'includeResults': 'true',
          'includeTotal': 'true'
        };
      }
      this._vizixClient.getThingsAssociation(whereValue, headerParams)
        .subscribe((data: any) => {
            console.log(this.tag, data);
            observer.next(data);
          },
          (err) => {
            console.log(this.tag, 'VizixGetThingAssociation - ' + err);
            observer.error(err);
          },
          () => {
            observer.complete();
          });
    });
  }

  setConfigurationApp(config: ConfigurationThing): void {
    this.configurationApp = config;
    console.log(this.tag, "Setting Configuration", this.configurationApp);
  }

  setStoreId(id: number) {
    this.storeID = id;
  }

  getStoreId(): number {
    return this.storeID;
  }

  //will return a zones array
  getVizixZones(selectedDepartment, vizixDepartmentArray) {
    let departmentZones;
    //as vizixDepartmentArray has All option and it is the first one, index needs to be index-1 to find the real values
    let index = vizixDepartmentArray.findIndex(i => i === selectedDepartment);
    departmentZones = this.zoneDeptList[index].Zones;

    return departmentZones;
  }

  getFirstDifferentsZones(includeAllZone: boolean): ZoneType[] {
    let result: ZoneType[];
    result = [];

    console.log(this.tag, 'Zone Dept list', this.zoneDeptList);

    for (let department of this.zoneDeptList) {
      for (let zone of department.Zones) {
        let zoneExist = false;
        for (let zoneResult of result) {
          if (zoneResult.zoneTypeCode == zone.zoneTypeCode) {
            zoneExist = true;
            break;
          }
        }
        // only unique zones
        if (!zoneExist) {
          if (!includeAllZone && department.ALL) {
            console.log(this.tag, "we ignore all zones");
          }
          else {
            result.push(zone);
          }
        }
      }
    }
    return result;
  }

  // This is promise, because we can call it multiple times for UPC or SKU, the returned Observable is global (private)
  // private lookupProductObservable(body: {}): Promise<ReportExecutionResponse> {
  //   return new Promise<ReportExecutionResponse>((resolve, reject) => {
  //     this._vizixClient.mortalReport({
  //       id: this.configurationApp.IdentifyItemConfiguration.IdentifyProductReportId.value,
  //       body: body,
  //       headers: {'pageNumber': '1', 'pageSize': '100000'}
  //     })
  //       .subscribe((data: ReportExecutionResponse) => {
  //           console.log(this.tag, 'Report Execution Response', data);
  //
  //           let findItemIdentifyResponse = deserialize<ReportExecutionResponse>(ReportExecutionResponse, data);
  //           console.log(this.tag, 'Deserialized Response: ', findItemIdentifyResponse);
  //
  //           if (findItemIdentifyResponse.results.length > 0) {
  //             resolve(findItemIdentifyResponse); // Result found!
  //           } else {
  //             reject({message: 'Tag not found!', errorCode: NOT_FOUND}); // No Tag found!
  //           }
  //         },
  //         (err) => {
  //           console.log(this.tag, 'Error Report Execution', err);
  //           reject(err);
  //         },
  //         () => {
  //           console.log(this.tag, 'Report Execution Complete');
  //         });
  //
  //   });
  // }

  VizixGetUnassociatedTagsPrefix(): Observable<string> {
    return Observable.create((observer: Observer<string>) => {
      this._vizixClient.GetReportDefinition(this.configurationApp.UnassociatedConfiguration.ReportUnassociatedId.value,
        {'only': 'id,name,reportFilter,reportProperty,reportEntryOption'}).subscribe((data: any) => {
          for (let listFormProperty of data.getReportFilter()) {
            if (listFormProperty.propertyName == KEYS_SERIAL) {
              observer.next(listFormProperty.value);
              break;
            }
          }
          observer.complete();
        },
        (err) => {
          console.log(this.tag, 'errorGetConfig - ', err);
          observer.error(err);
          observer.complete();
        },
        () => {
          observer.complete();
        });

    });
  }

  VizixGetReplenishmentTasks(id_report, map): Observable<any> {
    return Observable.create((observer: Observer<ConfigurationThing[]>) => {
      this._vizixClient.reportExecutionTableScript(id_report, map, {
        'pageNumber': '1',
        'pageSize': '100000'
      }).subscribe((data: any) => {
          observer.next(data);
        },
        err => {
          console.log('Replenishment ts errorGetConfig', err);
          observer.error(err);
          observer.complete();
        },
        () => {
          observer.complete();
        });

    });
  }

  VizixReplenishmentGetTotalRows(id_report, map): Observable<number> {
    return Observable.create((observer: Observer<number>) => {
      this._vizixClient.reportExecutionTableScript(id_report, map).subscribe((data: any) => {
          observer.next(data.totalRows);
        },
        err => {
          observer.error(err);
        },
        () => {
        });
    });
  }

  VizixGetVizixEventsGroup(vizixEventThingName: string): Observable<string> {
    return Observable.create((observer: Observer<string>) => {
      this._vizixClient.getGroupBySerialNumber(vizixEventThingName).subscribe((response) => {

        console.log(this.tag, 'Vizix Group response', response);

        let hierarchyName = response.hierarchyName;
        let groupName = response.groupName;

        let splitGroup = hierarchyName.split('|');

        if (splitGroup[1] == groupName) {
          observer.next(hierarchyName);
        } else {
          if (splitGroup.length > 2 &&
            splitGroup[splitGroup.length - 1] != groupName) {
            observer.next(hierarchyName + '>' + groupName);
          } else {
            observer.next(hierarchyName);
          }
        }

        observer.complete();
      }, (error) => {
        observer.error(error);
        observer.complete();
      });
    });
  }

  VizixGetThingTypeGroup(thingTypeCode: string): Observable<string> {
    return Observable.create((observer: Observer<string>) => {
      this._vizixClient.getGroupByThingType(thingTypeCode).subscribe((response) => {
        observer.next(response);
        observer.complete();
      }, (error) => {
        observer.error(error);
        observer.complete();
      });
    });
  }


  public timestamp(): Observable<{ offset: number, timestamp: number }> {
    return this._vizixClient.timestamp();
  }

  public vizixTime(): number {
    let offset = parseFloat(localStorage.getItem(STORAGE_TIME_OFFSET));
    return new Date().getTime() - offset;
  }

  private uploadEvent(vizixEvent: VizixEventItem, resolve, reject, bridgeCode?: string, thingTypeCode?: string) {
    let body: Array<any> = [];
    let requestItem = new PatchThingRequestItem();

    requestItem.timestamp = vizixEvent.eventDate != 0 ? vizixEvent.eventDate : this.vizixTime();
    requestItem.serialNumber = this.configurationApp.AppParametersConfiguration.ViZIxEventSerial.value;
    requestItem.name = this.configurationApp.AppParametersConfiguration.ViZIxEventSerial.value;
    requestItem.group = this.vizixEventGroup;
    requestItem.thingTypeCode = THING_TYPE_VIZIX_EVENT;
    requestItem.udfs = {};

    // Fill all the UDFs if available

    switch (vizixEvent.action) {
      case VizixEventAction.START:
        requestItem.udfs[VIZIX_EVENT_UDF_ACTION] = new StringUDF(VIZIX_EVENT_ACTION_START);
        break;
      case VizixEventAction.END:
        requestItem.udfs[VIZIX_EVENT_UDF_ACTION] = new StringUDF(VIZIX_EVENT_ACTION_END);
        break;
      case VizixEventAction.PROCESSED:
        requestItem.udfs[VIZIX_EVENT_UDF_ACTION] = new StringUDF(VIZIX_EVENT_ACTION_PROCESSED);
        break;
      case VizixEventAction.CONNECT:
        requestItem.udfs[VIZIX_EVENT_UDF_ACTION] = new StringUDF(VIZIX_EVENT_ACTION_CONNECT);
        break;
      case VizixEventAction.RETRIEVE:
        requestItem.udfs[VIZIX_EVENT_UDF_ACTION] = new StringUDF(VIZIX_EVENT_ACTION_RETRIEVE);
        break;
      case VizixEventAction.WRITE_TAG:
        requestItem.udfs[VIZIX_EVENT_UDF_ACTION] = new StringUDF(VIZIX_EVENT_ACTION_WRITE_TAG);
        break;
      case VizixEventAction.GET_SERIAL_FROM_THING:
        requestItem.udfs[VIZIX_EVENT_UDF_ACTION] = new StringUDF(VIZIX_EVENT_ACTION_WRITE_GET_SERIAL_FROM_THING);
        break;
      case VizixEventAction.CREATE_ENCODE_TAG:
        requestItem.udfs[VIZIX_EVENT_UDF_ACTION] = new StringUDF(VIZIX_EVENT_ACTION_WRITE_CREATE_ENCODE_TAG);
        break;
      case VizixEventAction.NONE:
        requestItem.udfs[VIZIX_EVENT_UDF_ACTION] = new StringUDF(VALUE_EMPTY);
        break;
      default:
        requestItem.udfs[VIZIX_EVENT_UDF_ACTION] = new StringUDF(VALUE_EMPTY);
        break;
    }

    switch (vizixEvent.activity) {
      case VizixEventActivity.ASSOCIATION_CREATE:
        requestItem.udfs[VIZIX_EVENT_UDF_ACTIVITY] = new StringUDF(VIZIX_EVENT_ACTIVITY_ASSOCIATION_CREATE);
        break;
      case VizixEventActivity.ASSOCIATION_UPDATE:
        requestItem.udfs[VIZIX_EVENT_UDF_ACTIVITY] = new StringUDF(VIZIX_EVENT_ACTIVITY_ASSOCIATION_UPDATE);
        break;
      case VizixEventActivity.CREATE_DEFAULT_PRODUCT:
        requestItem.udfs[VIZIX_EVENT_UDF_ACTIVITY] = new StringUDF(VIZIX_EVENT_ACTIVITY_CREATE_DEFAULT_PRODUCT);
        break;
      case VizixEventActivity.LOGIN:
        requestItem.udfs[VIZIX_EVENT_UDF_ACTIVITY] = new StringUDF(VIZIX_EVENT_ACTIVITY_LOGIN);
        break;
      case VizixEventActivity.LOGOUT:
        requestItem.udfs[VIZIX_EVENT_UDF_ACTIVITY] = new StringUDF(VIZIX_EVENT_ACTIVITY_LOGOUT);
        break;
      case VizixEventActivity.READER_CONNECT:
        requestItem.udfs[VIZIX_EVENT_UDF_ACTIVITY] = new StringUDF(VIZIX_EVENT_ACTIVITY_READER_CONNECT);
        break;
      case VizixEventActivity.SYNC:
        requestItem.udfs[VIZIX_EVENT_UDF_ACTIVITY] = new StringUDF(VIZIX_EVENT_ACTIVITY_SYNC);
        break;
      case VizixEventActivity.CHANGE_STATUS:
        requestItem.udfs[VIZIX_EVENT_UDF_ACTIVITY] = new StringUDF(VIZIX_EVENT_ACTIVITY_CHANGE_STATUS);
        break;
      case VizixEventActivity.ENCODE_TAG:
        requestItem.udfs[VIZIX_EVENT_UDF_ACTIVITY] = new StringUDF(VIZIX_EVENT_ACTIVITY_ENCODE_TAG);
        break;
      case VizixEventActivity.NONE:
        requestItem.udfs[VIZIX_EVENT_UDF_ACTIVITY] = new StringUDF(VALUE_EMPTY);
        break;
      default:
        requestItem.udfs[VIZIX_EVENT_UDF_ACTIVITY] = new StringUDF(VALUE_EMPTY);
        break;
    }

    switch (vizixEvent.eventType) {
      case VizixEventEventType.INFO:
        requestItem.udfs[VIZIX_EVENT_UDF_EVENT_TYPE] = new StringUDF(VIZIX_EVENT_EVENT_TYPE_INFO);
        break;
      case VizixEventEventType.WARN:
        requestItem.udfs[VIZIX_EVENT_UDF_EVENT_TYPE] = new StringUDF(VIZIX_EVENT_EVENT_TYPE_WARN);
        break;
      case VizixEventEventType.ERROR:
        requestItem.udfs[VIZIX_EVENT_UDF_EVENT_TYPE] = new StringUDF(VIZIX_EVENT_EVENT_TYPE_ERROR);
        break;
      case VizixEventEventType.NONE:
        requestItem.udfs[VIZIX_EVENT_UDF_EVENT_TYPE] = new StringUDF(VALUE_EMPTY);
        break;
      default:
        requestItem.udfs[VIZIX_EVENT_UDF_EVENT_TYPE] = new StringUDF(VALUE_EMPTY);
        break;
    }

    switch (vizixEvent.source) {
      case VizixEventSource.MOBILE:
        requestItem.udfs[VIZIX_EVENT_UDF_SOURCE] = new StringUDF(VIZIX_EVENT_SOURCE_MOBILE);
        break;
      case VizixEventSource.NONE:
        requestItem.udfs[VIZIX_EVENT_UDF_SOURCE] = new StringUDF(VALUE_EMPTY);
        break;
      default:
        requestItem.udfs[VIZIX_EVENT_UDF_SOURCE] = new StringUDF(VALUE_EMPTY);
        break;
    }

    switch (vizixEvent.status) {
      case VizixEventStatus.SUCCESS:
        requestItem.udfs[VIZIX_EVENT_UDF_STATUS] = new StringUDF(VIZIX_EVENT_STATUS_SUCCESS);
        break;
      case VizixEventStatus.FAILURE:
        requestItem.udfs[VIZIX_EVENT_UDF_STATUS] = new StringUDF(VIZIX_EVENT_STATUS_FAILURE);
        break;
      case VizixEventStatus.NONE:
        requestItem.udfs[VIZIX_EVENT_UDF_STATUS] = new StringUDF(VALUE_EMPTY);
        break;
      default:
        requestItem.udfs[VIZIX_EVENT_UDF_STATUS] = new StringUDF(VALUE_EMPTY);
        break;
    }

    switch (vizixEvent.category) {
      case VizixEventCategory.WORKFLOW:
        requestItem.udfs[VIZIX_EVENT_UDF_CATEGORY] = new StringUDF(VIZIX_EVENT_CATEGORY_WORKFLOW);
        break;
      case VizixEventCategory.SECURITY:
        requestItem.udfs[VIZIX_EVENT_UDF_CATEGORY] = new StringUDF(VIZIX_EVENT_CATEGORY_SECURITY);
        break;
      case VizixEventCategory.NONE:
        requestItem.udfs[VIZIX_EVENT_UDF_CATEGORY] = new StringUDF(VALUE_EMPTY);
        break;
      default:
        requestItem.udfs[VIZIX_EVENT_UDF_CATEGORY] = new StringUDF(VALUE_EMPTY);
        break;
    }

    switch (vizixEvent.subCategory) {
      case VizixEventSubCategory.AUTHENTICATION:
        requestItem.udfs[VIZIX_EVENT_UDF_SUB_CATEGORY] = new StringUDF(VIZIX_EVENT_SUB_CATEGORY_AUTHENTICATION);
        break;
      case VizixEventSubCategory.READER:
        requestItem.udfs[VIZIX_EVENT_UDF_SUB_CATEGORY] = new StringUDF(VIZIX_EVENT_SUB_CATEGORY_READER);
        break;
      case VizixEventSubCategory.MANAGE_TAGS:
        requestItem.udfs[VIZIX_EVENT_UDF_SUB_CATEGORY] = new StringUDF(VIZIX_EVENT_SUB_CATEGORY_MANAGE_TAGS);
        break;
      case VizixEventSubCategory.CHANGE_STATUS:
        requestItem.udfs[VIZIX_EVENT_UDF_SUB_CATEGORY] = new StringUDF(VIZIX_EVENT_SUB_CATEGORY_CHANGE_STATUS);
        break;
      case VizixEventSubCategory.CYCLE_COUNT:
        requestItem.udfs[VIZIX_EVENT_UDF_SUB_CATEGORY] = new StringUDF(VIZIX_EVENT_SUB_CATEGORY_CYCLE_COUNT);
        break;
      case VizixEventSubCategory.IDENTIFY_TAG:
        requestItem.udfs[VIZIX_EVENT_UDF_SUB_CATEGORY] = new StringUDF(VIZIX_EVENT_SUB_CATEGORY_IDENTIFY_TAG);
        break;
      case VizixEventSubCategory.FIND_ITEMS:
        requestItem.udfs[VIZIX_EVENT_UDF_SUB_CATEGORY] = new StringUDF(VIZIX_EVENT_SUB_CATEGORY_FIND_ITEMS);
        break;
      case VizixEventSubCategory.UNASSOCIATED_TAGS:
        requestItem.udfs[VIZIX_EVENT_UDF_SUB_CATEGORY] = new StringUDF(VIZIX_EVENT_SUB_CATEGORY_UNASSOCIATED_TAGS);
        break;
      case VizixEventSubCategory.ENCODE_TAG:
        requestItem.udfs[VIZIX_EVENT_UDF_SUB_CATEGORY] = new StringUDF(VIZIX_EVENT_SUB_CATEGORY_ENCODE_TAGS);
        break;
      case VizixEventSubCategory.NONE:
        requestItem.udfs[VIZIX_EVENT_UDF_SUB_CATEGORY] = new StringUDF(VALUE_EMPTY);
        break;
      default:
        requestItem.udfs[VIZIX_EVENT_UDF_SUB_CATEGORY] = new StringUDF(VALUE_EMPTY);
        break;
    }

    if (vizixEvent.description && vizixEvent.description != '') {
      requestItem.udfs[VIZIX_EVENT_UDF_DESCRIPTION] = new StringUDF(vizixEvent.description);
    } else {
      requestItem.udfs[VIZIX_EVENT_UDF_DESCRIPTION] = new StringUDF(VALUE_EMPTY);
    }

    if (vizixEvent.count && vizixEvent.count > 0) {
      requestItem.udfs[VIZIX_EVENT_UDF_COUNT] = new NumberUDF(vizixEvent.count);
    } else {
      requestItem.udfs[VIZIX_EVENT_UDF_COUNT] = new NumberUDF(0);
    }

    if (vizixEvent.detail && vizixEvent.detail != '') {
      requestItem.udfs[VIZIX_EVENT_UDF_DETAIL] = new StringUDF(vizixEvent.detail);
    } else {
      requestItem.udfs[VIZIX_EVENT_UDF_DETAIL] = new StringUDF(VALUE_EMPTY);
    }

    if (vizixEvent.eventDate != 0) {
      requestItem.udfs[VIZIX_EVENT_UDF_EVENT_DATE] = new NumberUDF(vizixEvent.eventDate);
    } else {
      requestItem.udfs[VIZIX_EVENT_UDF_EVENT_DATE] = new NumberUDF(this.vizixTime()); // Can't send eventDate = 0
    }

    if (vizixEvent.eventId && vizixEvent.eventId != '') {
      requestItem.udfs[VIZIX_EVENT_UDF_EVENT_ID] = new StringUDF(vizixEvent.eventId);
    } else {
      requestItem.udfs[VIZIX_EVENT_UDF_EVENT_ID] = new StringUDF(VALUE_EMPTY);
    }

    if (vizixEvent.remoteSource && vizixEvent.remoteSource != '') {
      requestItem.udfs[VIZIX_EVENT_UDF_REMOTE_SOURCE] = new StringUDF(vizixEvent.remoteSource);
    } else {
      requestItem.udfs[VIZIX_EVENT_UDF_REMOTE_SOURCE] = new StringUDF(VALUE_EMPTY);
    }

    if (vizixEvent.user && vizixEvent.user != '') {
      requestItem.udfs[VIZIX_EVENT_UDF_USER] = new StringUDF(vizixEvent.user);
    } else {
      requestItem.udfs[VIZIX_EVENT_UDF_USER] = new StringUDF(VALUE_EMPTY);
    }

    if (vizixEvent.userGroup && vizixEvent.userGroup != '') {
      requestItem.udfs[VIZIX_EVENT_UDF_USER_GROUP] = new StringUDF(vizixEvent.userGroup);
    } else {
      requestItem.udfs[VIZIX_EVENT_UDF_USER_GROUP] = new StringUDF(this.configurationApp.AppParametersConfiguration.VisibilityGroupId.value);
    }

    if (vizixEvent.userTenant && vizixEvent.userTenant != '') {
      requestItem.udfs[VIZIX_EVENT_UDF_USER_TENANT] = new StringUDF(vizixEvent.userTenant);
    } else {
      requestItem.udfs[VIZIX_EVENT_UDF_USER_TENANT] = new StringUDF(VALUE_EMPTY);
    }

    body.push(requestItem);

    console.log(this.tag, 'Saving event', requestItem);

    this.VizixPatchItem(body, {'upsert': 'true'}, bridgeCode,
      thingTypeCode, THING_BRIDGE_SOURCE_EVENT).subscribe((response) => {
      console.log(this.tag, 'OK Response', response);
      resolve(true);
    }, (error) => {
      console.log(this.tag, 'Error', error);
      reject(error);
    });
  }

  VizixLogOut(): Observable<any> {
    return this._vizixClient.logout();
  }

  public validateUpc(value: string): string {
    let regExp = new RegExp(this.configurationApp.AppParametersConfiguration.UPCValidation.value);
    if (!this.configurationApp.AppParametersConfiguration.DisableUPCCheck.value) {
      return regExp.test(value) ? value : '';
    } else {
      return value;
    }
  }

  public validateSku(value: string): string {
    let regExp = new RegExp(this.configurationApp.AppParametersConfiguration.SKUValidation.value);
    return regExp.test(value) ? value : '';
  }

  public validateRfid(value: string): string {
    let regExp = new RegExp(this.configurationApp.AppParametersConfiguration.RFIDValidation.value);
    return regExp.test(value) ? value : "";
  }

  public padUpc(value: string): string {
    try {
      if (this.configurationApp.AppParametersConfiguration.AutoPadUPC.value) {
        while (value.length < Number(this.configurationApp.AppParametersConfiguration.UPCLength.value)) {
          value = "0" + value;
        }
      }
    }
    catch (e) {
    }

    return value;
  }

  public padSku(value: string): string {
    if (this.configurationApp.AppParametersConfiguration.AutoPadSKU.value) {
      while (value.length < Number(this.configurationApp.AppParametersConfiguration.SKULength.value)) {
        value = "0" + value;
      }
    }
    console.log(this.tag, 'Padded Sku: ' + value);
    return value;
  }

  public formatDataType(label: string, value: any, dataTypes: any) {
    let dataTypeId: number = null;

    // Iterate datatypes
    for (let dataType of dataTypes) {
      // Now we check if the label is in the dataTypeIds (it should)
      if (dataType.name == label) {
        dataTypeId = dataType.dataTypeId;
        break;
      }
    }

    if (dataTypeId) {
      // Here we check if the value is null or not
      if (value == null || value == 'null') {
        value = '';
      }

      switch (dataTypeId) {
        case FIELD_TYPE_NAME:
          return value;
        case FIELD_TYPE_STRING:
          return value;
        case FIELD_TYPE_COORDINATE:
          return value;
        case FIELD_TYPE_NUMBER:
          return String(value);
        case FIELD_TYPE_BOOLEAN:
          return value ? 'True' : 'False';
        case FIELD_TYPE_IMAGE:
          return value;
        case FIELD_TYPE_ZONE:
          return value;
        case FIELD_TYPE_DATE:
          if (value.ts) {
            return new Date(value.ts).toLocaleDateString() + ' ' + new Date(value.ts).toLocaleTimeString();
          } else {
            return '';
          }
        case FIELD_TYPE_TIMESTAMP:
          if (value.ts) {
            return new Date(value.ts).toLocaleDateString() + ' ' + new Date(value.ts).toLocaleTimeString();
          } else {
            return '';
          }
        case FIELD_TYPE_ATTACHMENT:
          return String(value);
        case FIELD_TYPE_UDF:
          return String(value);
        default:
          return String(value);
      }
    } else {
      return String(value);
    }
  }

  private putUDFValueProperty(stringUDF: string): string {
    let UDFsWithoutValueProperty = ["_id", "groupTypeId", "groupTypeName", "groupTypeCode", "groupId", "groupCode", "groupName", "thingTypeId", "thingTypeCode", "thingTypeName", "name", "serialNumber", "modifiedTime", "createdTime", "time"];
    for (let UDFWithoutValue of UDFsWithoutValueProperty) {
      if (UDFWithoutValue == stringUDF) {
        return stringUDF;
      }
    }
    return stringUDF + ".value";
  }

  public getCycleCountFilterColumnsDefinition(): Observable<Array<{ displayOrder: number, label: string }>> {
    return this._vizixClient.GetReportDefinition(this.configurationApp.CycleCountConfiguration.ExpectedReportId.value, {'only': 'id,name,reportFilter,reportProperty,reportEntryOption'})
      .map((response: ReportDefinitionResponse) => response.getReportFilter())
      .map((reportFilter: Array<ReportFilter>) => {
        return reportFilter.map((filter: ReportFilter) => ({
          displayOrder: filter.displayOrder,
          label: filter.label
        }));
      });
  }

  /**
   * Remove the quantifiers of a regular expression
   * @param {string} regEx
   * @returns {string}
   */
  public removeQuantifiersOfRegularExpression(regEx: string): string {
    let result = '';
    let listQuantifiers = ['?', '*', '+'];
    let listQuantifiersRange = [];
    listQuantifiersRange[0] = ['{', '}'];
    listQuantifiersRange[1] = ['(', ')'];
    let i = 0;
    while (i < regEx.length) {
      // remove the single quantifiers
      let matchQuantifier = false;
      for (let quantifier of listQuantifiers) {
        if (regEx.charAt(i) == quantifier) {
          matchQuantifier = true;
          break;
        }
      }
      if (matchQuantifier) {
        i++;
      }
      else {
        // remove the range Quantifiers
        for (let rangeQuantifier of listQuantifiersRange) {
          if (regEx.charAt(i) == rangeQuantifier[0]) {
            while (regEx.charAt(i) != rangeQuantifier[1] && i < regEx.length) {
              i++;
            }
            i++;
          }
        }
        if (i < regEx.length) {
          if (regEx.charAt(i) != '+' && regEx.charAt(i) != '?' && regEx.charAt(i) != '*') {
            result = result + regEx.charAt(i);
          }
          i++;
        }
      }
    }
    return result;
  }

}



// WEBPACK FOOTER //
// ./src/providers/vizix.service.ts